// extracted by mini-css-extract-plugin
export default {"date":"styles_date__az4c2","date__duration":"styles_date__duration__B+g6n"};